export default {
  id: 'location.gracePeriod',
  name: 'location.gracePeriod',
  displayName: 'Grace Period',
  valueType: 'string',
  objectType: 'location',
  blueprint: {},
  get: obj => obj?.data?.company?.id
};